import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ElementsService {
  constructor() {}

  private _isEmbeddedInAngularApp = true;

  public get isEmbeddedInAngularApp(): boolean {
    return this._isEmbeddedInAngularApp;
  }

  public setAngularContext(elementRef: ElementRef): void {
    this._isEmbeddedInAngularApp = this.setIsEmbeddedInAnuglarApp(elementRef);
  }

  private setIsEmbeddedInAnuglarApp(elementRef: ElementRef) {
    let parent = elementRef.nativeElement.parentElement;

    while (parent) {
      if (parent.hasAttribute('ng-version')) {
        return true; // Found an ancestor Angular component
      }
      parent = parent.parentElement; // Move up the DOM tree
    }

    return false; // No Angular component found above
  }
}
